// extracted by mini-css-extract-plugin
export default {"status-text":"gcwFHo_GbGDIbRuoaDVb","file-name":"xur0rVMn9i6dQqMaHyY_"};